import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';
import CustomInput from '../../../../components/customInput';

export default function UpdateDialog({
  open,
  handleOpen,
  handleClose,
  reloadData,
  commentaireData,
}) {
  const [commentaire, setCommentaire] = useState(commentaireData?.commentaire);
  const [commentaireEn, setCommentaireEn] = useState(commentaireData?.commentaire_en);
  const [commentaireError, setCommentaireError] = useState('');
  const [commentaireEnError, setCommentaireEnError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function editCommentaire() {
    const url = `${getEnvironement().API_URL}/commentaires/${commentaireData.id}`;
    const data = {
      commentaire,
      commentaireEn
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.put(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le commentaire a bien été modifié'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.commentaire ? setCommentaireError(err.response.data.errors.commentaire[0]) : setCommentaireError('');
          err.response.data.errors.commentaireEn ? setCommentaireEnError(err.response.data.errors.commentaireEn[0]) : setCommentaireEnError('');
          handleOpen();
        }
      });
  }

  useEffect(() => {
    if (open) {
      setCommentaire(commentaireData?.commentaire);
      setCommentaireEn(commentaireData?.commentaire_en);
    }
    if (!open) {
      setCommentaireError('');
      setCommentaireEnError('');
    }
  }, [commentaireData?.commentaire, commentaireData?.commentaire_en, open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Commentaire : {commentaireData?.id}</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomInput
              type='textarea'
              placeholder='Commentaire'
              value={commentaire}
              setValue={setCommentaire}
              isError={commentaireError !== ''}
              error={commentaireError}
            />
            <CustomInput
              type='textarea'
              placeholder='Commentaire (anglais)'
              value={commentaireEn}
              setValue={setCommentaireEn}
              isError={commentaireEnError !== ''}
              error={commentaireEnError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={editCommentaire}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Confirmer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
